/**
 * JOMetiers — 3 big metier cards (Jardinerie / Paysagiste / Décoration)
 * Reads services from /api/services
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

const FALLBACK = [
  { title: "La Jardinerie", short_description: "Sur 3 000 m², plus de 3 000 références sélectionnées avec passion.", image_url: "", slug: "jardinerie" },
  { title: "Paysagiste", short_description: "Conception, création et entretien d'espaces verts depuis 1993.", image_url: "", slug: "paysagiste" },
  { title: "Décoration", short_description: "Une large gamme d'objets décoratifs, accessoires et statues.", image_url: "", slug: "decoration" },
];

export default function JOMetiers() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const res = await api.get("/services");
        if (!cancel) setServices((res.data || []).filter(s => s.featured).slice(0, 3));
      } catch { /* ignore */ }
    })();
    return () => { cancel = true; };
  }, []);

  const items = services.length > 0 ? services : FALLBACK;

  return (
    <section className="jo-section" data-testid="jo-metiers">
      <div className="jo-container">
        <div className="max-w-2xl mb-14">
          <div className="jo-section-eyebrow">— Trois métiers, une passion</div>
          <h2 className="jo-section-title">
            Du semis<br />à la livraison clé en main
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {items.map((s, idx) => (
            <Link
              key={s.id || s.slug || idx}
              to={`/services/${s.slug}`}
              className="jo-metier-card"
              data-testid={`jo-metier-${s.slug}`}
            >
              <div className="jo-metier-image">
                {s.image_url ? (
                  <img src={s.image_url} alt={s.title} />
                ) : (
                  <div style={{ background: "var(--jdo-sage)", height: "100%" }} />
                )}
                <div className="jo-metier-tag">{`0${idx + 1}`}</div>
              </div>
              <div className="jo-metier-body">
                <h3>{s.title}</h3>
                <p>{s.short_description}</p>
                <span className="jo-metier-link">
                  Découvrir <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
